@if (label) {
<label class="_label p2">{{label}}</label>
}

<div class="_content">
    <ng-content />

    <!-- loader -->
    @if (isLoaderVisible) {
    <loader class="_loader" />
    }

    <!-- side icon (optional) -->
    @if (sideIcon) {
    <i [ngClass]="sideIcon"
       class="_sideIcon"
       (click)="sideAction()"></i>
    }

    <!-- side text (optional) -->
    @if (sideText) {
    <span class="_sideText s2"
          (click)="sideAction()">{{ sideText | translate }}</span>
    }
</div>

<p class="p2 m-t-1 col-2 _validation">{{ validationMsg | translate }}</p>

@if (helper) {
<p class="p2 m-t-1 _helper">{{ helper| translate }}</p>
}